// src/pages/HomePage.jsx

import React from 'react';
import '../App.css';

// We only need the components and images for the page's content
import ScrollStack, { ScrollStackItem } from '../components/ScrollStack/ScrollStack';
import lunarLanderImg from '../assets/images/gif3.gif';
import jugaadRajuImg from '../assets/images/gif2.gif';
import wasteNotImg from '../assets/images/gif1.gif';
import unrealLogo from '../assets/images/logos/unreal-engine.svg';
import unityLogo from '../assets/images/logos/unity.svg';
import blenderLogo from '../assets/images/logos/blender.svg';
import discordIcon from '../assets/images/icons/discord-icon.svg';
import gmailIcon from '../assets/images/icons/gmail-icon.svg';

const HomePage = () => {
  return (
    // Use a React Fragment because the outer wrapper is in Layout.jsx
    <>
      <section className="App-hero-section">
        <div className="hero-content">
          <h1 className="hero-headline">Where Every Pixel Sparks Adventure</h1>
        </div>
      </section>

      <section className="App-projects-section">
        <ScrollStack itemDistance={10} useWindowScroll={true}>
          <ScrollStackItem>
            <div className="title-card-content">
              <h1 className="game-title">Upcoming Games</h1>
            </div>
          </ScrollStackItem>
          <ScrollStackItem>
            <div className="game-card-content">
              <img src={lunarLanderImg} alt="Lunar Lander game" className="game-image" />
              <div className="game-details">
                <h1 className="game-title">DunkMoon!</h1>
                <p className="game-description">A modern take on the classic arcade game. Navigate treacherous lunar surfaces, manage your fuel, and achieve a perfect landing.</p>
              </div>
            </div>
          </ScrollStackItem>
          <ScrollStackItem>
            <div className="game-card-content">
              <img src={jugaadRajuImg} alt="Jugaad Raju game" className="game-image" />
              <div className="game-details">
                <h1 className="game-title">Echoes</h1>
                <p className="game-description">An innovative horror game where you build makeshift contraptions to overcome obstacles and save your village.</p>
              </div>
            </div>
          </ScrollStackItem>
          <ScrollStackItem>
            <div className="game-card-content">
              <img src={wasteNotImg} alt="Waste Not! game" className="game-image" />
              <div className="game-details">
                <h1 className="game-title">Waste Not!</h1>
              </div>
            </div>
          </ScrollStackItem>
        </ScrollStack>
      </section>

      <section className="App-mission-section">
        <div className="mission-content">
          <h2>More Than Just Games.</h2>
          <p className="mission-statement">At Krida, we believe in crafting worlds that spark curiosity and forge connections. Our mission is to build immersive experiences that challenge the mind and tell unforgettable stories, one pixel at a time.</p>
        </div>
      </section>

      <section className="App-tech-section">
        <div className="tech-content">
          <h2>Powered by Industry-Leading Tech.</h2>
          <div className="tech-logo-grid">
            <div className="tech-logo-item"><img src={unrealLogo} alt="Unreal Engine 5" /></div>
            <div className="tech-logo-item"><img src={unityLogo} alt="Unity Game Engine" /></div>
            <div className="tech-logo-item"><img src={blenderLogo} alt="Blender" /></div>
          </div>
        </div>
      </section>

      <section className="App-join-section">
        <div className="join-content">
          <h2>Become Part of Krida.</h2>
          <div className="join-buttons-container">
            <a href="https://discord.gg/2cPravBAu2" target="_blank" rel="noopener noreferrer" className="join-button"><img src={discordIcon} alt="Discord" className="join-button-icon" />Join our Discord</a>
            <a href="mailto:info@krida.com?subject=Inquiry%20from%20the%20Krida%20Studio%20Website" className="join-button">
              <img src={gmailIcon} alt="Contact Us" className="join-button-icon" />
              Connect with us
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;